import { Directive, ElementRef, Renderer2, HostListener, Input } from '@angular/core';
import { NgControl, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[appOnlyDecimal]'
})
export class OnlyDecimalDirective {
  constructor(private _elementRef: ElementRef, private _renderer: Renderer2, private control: NgControl) { }



 //#region input Properties
 @Input()
 set onlydecimal(value: boolean) {
   this._allowOnlyDecimal = value;
 }
 //#endregion


  //#region Private Properties
  private _allowOnlyDecimal: boolean;
  //#endregion

  @HostListener('input')
  onInput() {

    if (this._allowOnlyDecimal) {
      let el = this._elementRef.nativeElement;

      if (el.tagName.toLowerCase() == 'input') {
        el = el as HTMLInputElement;
        const pattern = new RegExp('^((([0-9])*)((\\.[0-9]{1,8})?)|([0-9])+((\\.[0-9]{1,2}))|([0-9])+((\\.)))$');
        const isValid = pattern.test(el.value);

        if (isValid) {
          el.setAttribute('data-val', el.value);
        } else {

          const value = el.getAttribute('data-val');
          this.control && this.control.control && (this.control.control as AbstractControl).setValue(value);
        }
      }
    }

  }

  @HostListener('blur')
  onFocusOut() {
    if (this._allowOnlyDecimal) {
      let el = this._elementRef.nativeElement;

      if (el.tagName.toLowerCase() === 'input') {
        el = el as HTMLInputElement;
        const number = parseFloat(el.value);
        if (number > 0) {
          this.control && this.control.control && (this.control.control as AbstractControl).setValue(el.value);
        } else {
          this.control && this.control.control && (this.control.control as AbstractControl).setValue(null);
        }
      }
    }

  }
}
